import { instance } from '../instance'

/**
 * @param iban
 * @param currencyId
 * @param bankDetailsType
 * @return {Promise<axios.AxiosResponse<any>>}
 */
export const getIbanInfo = async ({ iban, currencyId, bankDetailsType }) => {
  return instance.post(`/v2/beneficiary/iban-info`, {
    iban,
    currencyId,
    bankDetailsType,
  })
}
